module.exports = __webpack_public_path__ + "static/img/Vector.97cd074.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Vector.svg
// module id = lvBo
// module chunks = 1